import { IFormTypesGroupCategory } from "../../model/formconfiguration/FormTypesGroupCategory";
import { IFormTypesGroupCategoryService } from "../../service/formconfiguration/FormTypesGroupCategoryService";

export default class CreateFormTypesGroupCategoryInteractor {
  private formTypesGroupCategoryService: IFormTypesGroupCategoryService;

  constructor(formTypesGroupCategoryService) {
    this.formTypesGroupCategoryService = formTypesGroupCategoryService;
  }

  async execute(formTypesGroupCategory: IFormTypesGroupCategory) {
    return this.formTypesGroupCategoryService.createFormTypesGroupCategory(
      formTypesGroupCategory
    );
  }
}
